'use client';

import { c as _c } from "react/compiler-runtime";
import { useIsMobile } from '@/hooks/useIsMobile';
import { isValidTab } from '@/lib/search';
import { cn } from '@/lib/utils';
import { AnimatePresence, motion } from 'framer-motion';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { CreatorCardSkeleton } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/CreatorCard';
import MobileGenresSection from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/MobileGenresSection';
import MobileSearchInput from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/MobileSearchInput';
import MobileSearchResultsSection from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/MobileSearchResultsSection';
import MobileSearchSuggestions from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/MobileSearchSuggestions';
import { RoomCardSkeleton } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/RoomCard';
import SearchResult from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SearchResult';
import { Separator } from '@/components/ui/separator';
import ViverseSkeleton from '@/components/ViverseSkeleton';
import { SEARCH_PARAM_KEYS } from '@/constants/search';
import { useLayoutContext } from '@/context/LayoutContext';
import { useUAContext } from '@/context/UAContext';
import { useWorldSearchContext } from '@/context/WorldSearchContext';
export default function MobileSearchResult() {
  const $ = _c(33);
  const {
    headerHeight,
    logoHeight
  } = useLayoutContext();
  const {
    isMobileApp
  } = useUAContext();
  const {
    isMobileMenuInteracting,
    mobileNavHeight,
    searchValue,
    setSearchValue,
    appShowFilters,
    appSearchCleared,
    setAppSearchCleared
  } = useWorldSearchContext();
  const searchParams = useSearchParams();
  const isMobile = useIsMobile();
  let t0;
  if ($[0] !== searchParams) {
    const tabParam = searchParams.get(SEARCH_PARAM_KEYS.TAB) || "top";
    t0 = isValidTab(tabParam) ? tabParam : "top";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const activeTab = t0;
  const [isSearchCleared, setIsSearchCleared] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams.get(SEARCH_PARAM_KEYS.KEYWORD);
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const urlSearchQuery = t1;
  const shouldShowSidebar = isMobileApp || isMobile && !isMobileMenuInteracting;
  const hiddenFilters = !searchValue || !urlSearchQuery || isSearchCleared || activeTab === "top";
  const filterModalTopOffset = isMobile ? logoHeight : undefined;
  const effectiveIsSearchCleared = isMobileApp ? appSearchCleared : isSearchCleared;
  const effectiveSetIsSearchCleared = isMobileApp ? setAppSearchCleared : setIsSearchCleared;
  let t2;
  let t3;
  if ($[4] !== effectiveIsSearchCleared || $[5] !== searchValue || $[6] !== setSearchValue || $[7] !== urlSearchQuery) {
    t2 = () => {
      if (urlSearchQuery && !searchValue && !effectiveIsSearchCleared) {
        setSearchValue(urlSearchQuery);
      }
    };
    t3 = [effectiveIsSearchCleared, searchValue, setSearchValue, urlSearchQuery];
    $[4] = effectiveIsSearchCleared;
    $[5] = searchValue;
    $[6] = setSearchValue;
    $[7] = urlSearchQuery;
    $[8] = t2;
    $[9] = t3;
  } else {
    t2 = $[8];
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] !== setSearchValue) {
    t4 = () => {
      setSearchValue("");
    };
    $[10] = setSearchValue;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleSearchComplete = t4;
  let t5;
  if ($[12] !== effectiveSetIsSearchCleared || $[13] !== setSearchValue || $[14] !== urlSearchQuery) {
    t5 = value => {
      setSearchValue(value);
      if (urlSearchQuery && !value) {
        effectiveSetIsSearchCleared(true);
      } else {
        if (value) {
          effectiveSetIsSearchCleared(false);
        }
      }
    };
    $[12] = effectiveSetIsSearchCleared;
    $[13] = setSearchValue;
    $[14] = urlSearchQuery;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const handleSearchValueChange = t5;
  let t6;
  if ($[16] !== appShowFilters || $[17] !== effectiveIsSearchCleared || $[18] !== effectiveSetIsSearchCleared || $[19] !== filterModalTopOffset || $[20] !== handleSearchComplete || $[21] !== handleSearchValueChange || $[22] !== headerHeight || $[23] !== hiddenFilters || $[24] !== isMobileApp || $[25] !== mobileNavHeight || $[26] !== searchValue || $[27] !== shouldShowSidebar || $[28] !== showFilters || $[29] !== urlSearchQuery) {
    t6 = shouldShowSidebar && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: "linear"
    }} className={cn("border-vive-surface-normal bg-background z-sticky flex flex-col overflow-x-hidden overflow-y-auto shadow-lg", isMobileApp ? "relative flex-1" : "fixed inset-x-0")} style={isMobileApp ? undefined : {
      height: `calc(100dvh - ${headerHeight}px - ${mobileNavHeight}px)`,
      bottom: `${mobileNavHeight}px`
    }}><div className="flex flex-1"><div className="relative flex w-full flex-col">{!isMobileApp && <MobileSearchInput onSearchValueChange={handleSearchValueChange} onSearchComplete={handleSearchComplete} showFilters={showFilters} onShowFiltersChange={setShowFilters} hiddenFilters={hiddenFilters} />}<AnimatePresence mode="popLayout">{!searchValue ? <><MobileSearchSuggestions showSuggestions={false} setIsSearchCleared={effectiveSetIsSearchCleared} /><MobileGenresSection /></> : urlSearchQuery && !effectiveIsSearchCleared ? <SearchResult hiddenToolbar={isMobileApp ? !appShowFilters : !showFilters} filterModalTopOffset={filterModalTopOffset} /> : <MobileSearchResultsSection setIsSearchCleared={effectiveSetIsSearchCleared} />}</AnimatePresence></div></div></motion.div>;
    $[16] = appShowFilters;
    $[17] = effectiveIsSearchCleared;
    $[18] = effectiveSetIsSearchCleared;
    $[19] = filterModalTopOffset;
    $[20] = handleSearchComplete;
    $[21] = handleSearchValueChange;
    $[22] = headerHeight;
    $[23] = hiddenFilters;
    $[24] = isMobileApp;
    $[25] = mobileNavHeight;
    $[26] = searchValue;
    $[27] = shouldShowSidebar;
    $[28] = showFilters;
    $[29] = urlSearchQuery;
    $[30] = t6;
  } else {
    t6 = $[30];
  }
  let t7;
  if ($[31] !== t6) {
    t7 = <AnimatePresence>{t6}</AnimatePresence>;
    $[31] = t6;
    $[32] = t7;
  } else {
    t7 = $[32];
  }
  return t7;
}
export function MobileSearchResultSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-background sticky top-0 z-interactive flex flex-col"><div className="flex items-center justify-between py-4"><div className="no-scrollbar flex w-full items-center gap-2 overflow-x-auto px-4"><div className="flex gap-2">{[1, 2, 3].map(_temp)}</div></div></div><Separator className="bg-vive-surface-normal" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ViverseSkeleton className="h-6 w-24" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-4">{t1}<div className="flex flex-col gap-4">{[1, 2, 3].map(_temp2)}</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ViverseSkeleton className="h-6 w-24" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-background relative w-full">{t0}<div className="flex flex-col p-4"><div className="flex flex-1 flex-col gap-4">{t2}<div className="flex flex-col gap-4">{t3}<div className="flex flex-col gap-4">{[1, 2, 3].map(_temp3)}</div></div></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp3(i_1) {
  return <CreatorCardSkeleton key={i_1} />;
}
function _temp2(i_0) {
  return <RoomCardSkeleton key={i_0} />;
}
function _temp(i) {
  return <ViverseSkeleton key={i} className="h-11 w-[100px] rounded-4xl" />;
}